import { cn } from '@lib/cn'
import React, { FC } from 'react'

export interface Icons {
  'caret-down': React.ReactElement
  'chevron-left': React.ReactElement
  'chevron-right': React.ReactElement
  'chevron-down': React.ReactElement
  'rolex-chevron-right': React.ReactElement
  'rolex-chevron-left': React.ReactElement
  'rolex-refresh-arrow': React.ReactElement
  'rolex-caret-down': React.ReactElement
  'rolex-mobile-menu-arrow': React.ReactElement
  'rolex-back-to-top-arrow': React.ReactElement
  info: React.ReactElement
  mail: React.ReactElement
  phone: React.ReactElement
  location: React.ReactElement
  'close-map-location': React.ReactElement
  directions: React.ReactElement
  externalLink: React.ReactElement
  plus: React.ReactElement
  minus: React.ReactElement
  cross: React.ReactElement
  whatsapp: React.ReactElement
  reset: React.ReactElement
  '360-view': React.ReactElement
}

export const icons: Icons = {
  'rolex-refresh-arrow': (
    <path
      d="M3.42615 14.9301H0L4.34883 19.5143L8.58796 14.9301H5.16181C5.2715 13.2391 5.68122 11.8025 6.38129 10.289C7.08781 8.76537 7.97822 7.46612 9.08801 6.36779C10.1978 5.26945 11.4979 4.41891 12.9981 3.77598C14.4853 3.13975 16.0468 2.80824 17.676 2.80824C19.9439 2.80824 22.0571 3.39424 23.996 4.57964C25.922 5.75834 27.4544 7.36901 28.5803 9.38821C29.7062 11.4074 30.2708 13.6074 30.2708 15.9849C30.2708 18.3624 29.7127 20.5825 28.5803 22.6151C27.4544 24.6377 25.922 26.2484 23.9927 27.4237C22.0538 28.6091 19.9407 29.1951 17.6727 29.1951C15.7177 29.1951 13.8401 28.7196 12.0722 27.782L11.3366 29.4563C13.3852 30.491 15.4983 31 17.6727 31C19.6117 31 21.4699 30.5982 23.2411 29.8012C25.0057 29.0076 26.5414 27.9461 27.8254 26.6C29.0933 25.2706 30.1159 23.68 30.8741 21.8249C31.6322 19.9731 32 18.0175 32 15.9816C32 13.9456 31.6322 12.0068 30.8741 10.155C30.1127 8.29657 29.0933 6.70265 27.8254 5.37995C26.5478 4.04722 25.0057 2.99241 23.2411 2.19545C21.4731 1.40183 19.6149 1 17.676 1C15.1886 1 12.8916 1.62619 10.7624 2.87186C8.62022 4.12423 6.89747 5.82532 5.60056 7.97511C4.30043 10.1249 3.56488 12.3517 3.42615 14.9301Z"
      fill="currentColor"
    />
  ),
  'caret-down': <path d="M8 0H0L4 5L8 0Z" fill="currentColor" />,
  'chevron-down': <path d="M16 20L10 14L12 12L16 16L20 12L22 14L16 20Z" fill="currentColor" />,
  'chevron-left': (
    <path
      d="M14.5746 16L20 10.7346L18.2127 9L11 16L18.2127 23L20 21.2654L14.5746 16Z"
      fill="currentColor"
    />
  ),
  'chevron-right': (
    <path
      d="M16.4254 16L11 21.2654L12.7873 23L20 16L12.7873 9L11 10.7346L16.4254 16Z"
      fill="currentColor"
    />
  ),
  'rolex-chevron-right': (
    <path
      d="M16.4254 16L11 21.2654L12.7873 23L20 16L12.7873 9L11 10.7346L16.4254 16Z"
      fill="currentColor"
    />
  ),
  'rolex-chevron-left': (
    <path
      d="M14.5746 16L20 10.7346L18.2127 9L11 16L18.2127 23L20 21.2654L14.5746 16Z"
      fill="currentColor"
    />
  ),
  'rolex-caret-down': <path d="M8 0H0L4 5L8 0Z" fill="currentColor" />,
  'rolex-mobile-menu-arrow': <path d="M16 18L12 14H20L16 18Z" fill="currentColor" />,
  'rolex-back-to-top-arrow': (
    <path
      d="M16 13.5746L21.2654 19L23 17.2127L16 10L9 17.2127L10.7346 19L16 13.5746Z"
      fill="currentColor"
    />
  ),
  info: (
    <>
      <g transform="translate(8.5, 8.5)">
        <path
          d="M7.5 0C3.4 0 0 3.4 0 7.5S3.4 15 7.5 15 15 11.6 15 7.5 11.6 0 7.5 0zm0 14.1c-3.6 0-6.6-3-6.6-6.6s3-6.6 6.6-6.6 6.6 3 6.6 6.6-2.5 6.6-6.6 6.6z"
          fill="currentColor"
        />
        <path
          d="M8.4 10.3c-.1.2-.3.4-.5.6-.1.1-.4.1-.4-.1l1.8-5.1h-3L6 6.6h1.2L6 10.1l-.3.8c-.1.3-.1.5 0 .8.3.5.9.5 1 .5s.4 0 .8-.2c.7-.4 1.2-1 1.4-1.4"
          fill="currentColor"
        />
        <circle cx="8.5" cy="3.8" r="1" fill="currentColor" />
      </g>
    </>
  ),
  mail: (
    <>
      <path
        d="M24.2422 8.38281H7.75782C7.48723 8.38281 7.23391 8.44934 7.00473 8.55898L15.9609 17.5152L17.9683 15.586C17.9683 15.586 17.9685 15.5858 17.9685 15.5857C17.9686 15.5857 17.9687 15.5856 17.9687 15.5856L24.9956 8.55914C24.7663 8.44941 24.5129 8.38281 24.2422 8.38281Z"
        fill="currentColor"
      />
      <path
        d="M25.8241 9.38782L19.2114 16.0001L25.8238 22.6125C25.9335 22.3833 26 22.13 26 21.8594V10.1406C26 9.8702 25.9336 9.61692 25.8241 9.38782Z"
        fill="currentColor"
      />
      <path
        d="M6.17617 9.38757C6.06652 9.61675 6 9.87007 6 10.1407V21.8594C6 22.1298 6.06645 22.3832 6.17602 22.6123L12.7886 16L6.17617 9.38757Z"
        fill="currentColor"
      />
      <path
        d="M18.3829 16.8287L16.3752 18.7581C16.2608 18.8726 16.1109 18.9298 15.961 18.9298C15.8111 18.9298 15.6611 18.8726 15.5467 18.7581L13.6172 16.8286L7.00446 23.4409C7.23367 23.5506 7.48715 23.6172 7.75781 23.6172H24.2422C24.5128 23.6172 24.7661 23.5507 24.9953 23.4411L18.3829 16.8287Z"
        fill="currentColor"
      />
    </>
  ),
  phone: (
    <path
      d="M25.6111 21.9032L23.3939 20.4249L21.4229 19.1112C21.0425 18.8581 20.5313 18.9411 20.2505 19.3015L19.0308 20.8694C18.7688 21.2097 18.2976 21.3074 17.9219 21.0994C17.0943 20.6391 16.1157 20.2057 13.9564 18.0436C11.7971 15.8816 11.3609 14.9057 10.9006 14.0781C10.6926 13.7024 10.7903 13.2312 11.1306 12.9692L12.6985 11.7496C13.0589 11.4688 13.1419 10.9576 12.8888 10.5772L11.6154 8.66684L10.0968 6.3889C9.8383 6.00117 9.32088 5.88477 8.92128 6.12441L7.16989 7.1751C6.69658 7.45397 6.34865 7.90427 6.19818 8.43267C5.71924 10.1789 5.62268 14.0309 11.7961 20.2042C17.9694 26.3776 21.8211 26.2807 23.5673 25.8018C24.0957 25.6513 24.546 25.3034 24.8249 24.83L25.8756 23.0787C26.1152 22.6791 25.9988 22.1617 25.6111 21.9032Z"
      fill="currentColor"
    />
  ),
  location: (
    <path
      d="M15.6667 6C11.9907 6 9 8.99074 9 12.6667C9 13.7702 9.2759 14.8643 9.80039 15.8348L15.3021 25.7852C15.3754 25.9178 15.5149 26 15.6667 26C15.8184 26 15.958 25.9178 16.0312 25.7852L21.535 15.8315C22.0575 14.8643 22.3334 13.7702 22.3334 12.6666C22.3334 8.99074 19.3426 6 15.6667 6ZM15.6667 16C13.8287 16 12.3334 14.5046 12.3334 12.6667C12.3334 10.8287 13.8287 9.33336 15.6667 9.33336C17.5046 9.33336 19 10.8287 19 12.6667C19 14.5046 17.5046 16 15.6667 16Z"
      fill="currentColor"
    />
  ),
  'close-map-location': (
    <path
      d="M16 15.1544L22.1544 9L23 9.8456L16.8456 16L23 22.1544L22.1544 23L16 16.8456L9.8456 23L9 22.1544L15.1544 16L9 9.8456L9.8456 9L16 15.1544Z"
      fill="currentColor"
    />
  ),
  directions: <path d="M6 16H16V26H17.1L26 6L6 14.9V16Z" fill="currentColor" />,
  externalLink: (
    <>
      <path
        d="M17.9375 25.125H6.4375V7.875H17.9375V10.75H19.375V7.875V6.4375H17.9375H6.47344H5.03594H5V7.875V25.125V26.5625H19.375V25.125V22.25H17.9375V25.125Z"
        fill="currentColor"
      />
      <path
        d="M25.8438 14.3438L23.6875 12.1875V15.7812H12.1875V17.2188H23.6875V20.8125L25.8438 18.6562L28 16.5L25.8438 14.3438Z"
        fill="currentColor"
      />
    </>
  ),
  plus: (
    <path
      d="M18.1429 17.7857C17.9456 17.7857 17.7857 17.9456 17.7857 18.1429V26H14.2143V18.1429C14.2143 17.9456 14.0544 17.7857 13.8571 17.7857H6V14.2143H13.8571C14.0544 14.2143 14.2143 14.0544 14.2143 13.8571V6H17.7857V13.8571C17.7857 14.0544 17.9456 14.2143 18.1429 14.2143H26V17.7857H18.1429Z"
      fill="currentColor"
    />
  ),
  minus: (
    <path
      d="M18.1429 17.7858C15.9201 17.7858 15.0307 17.7858 13.8571 17.7858H6V14.2143H13.8571C15.2761 14.2143 17.0392 14.2143 18.1429 14.2143H26V17.7858H18.1429Z"
      fill="currentColor"
    />
  ),
  cross: (
    <path
      d="M23.7071 9.70711L22.2929 8.29289L16 14.5858L9.70711 8.29289L8.29289 9.70711L14.5858 16L8.29289 22.2929L9.70711 23.7071L16 17.4142L22.2929 23.7071L23.7071 22.2929L17.4142 16L23.7071 9.70711Z"
      fill="currentColor"
    />
  ),
  whatsapp: (
    <path
      d="M16.0027 5H15.9973C9.93213 5 5 9.9335 5 16C5 18.4062 5.7755 20.6365 7.09413 22.4474L5.72325 26.5339L9.95138 25.1823C11.6908 26.3345 13.7656 27 16.0027 27C22.0679 27 27 22.0651 27 16C27 9.93488 22.0679 5 16.0027 5ZM22.4034 20.5334C22.138 21.2827 21.0847 21.9042 20.2446 22.0857C19.6699 22.2081 18.9191 22.3058 16.3919 21.258C13.1592 19.9188 11.0775 16.6339 10.9153 16.4207C10.7599 16.2076 9.609 14.6814 9.609 13.1029C9.609 11.5244 10.4106 10.7558 10.7338 10.4258C10.9991 10.1549 11.4377 10.0311 11.8585 10.0311C11.9946 10.0311 12.117 10.038 12.227 10.0435C12.5501 10.0572 12.7124 10.0765 12.9255 10.5866C13.1909 11.226 13.8371 12.8045 13.9141 12.9668C13.9925 13.129 14.0709 13.349 13.9609 13.5621C13.8578 13.7821 13.767 13.8797 13.6047 14.0667C13.4425 14.2537 13.2885 14.3968 13.1262 14.5975C12.9777 14.7721 12.81 14.9591 12.997 15.2823C13.184 15.5985 13.8302 16.6531 14.7817 17.5001C16.0096 18.5932 17.0051 18.9425 17.3612 19.091C17.6266 19.201 17.9429 19.1749 18.1367 18.9686C18.3829 18.7033 18.6867 18.2633 18.9961 17.8301C19.2161 17.5194 19.4939 17.4809 19.7854 17.5909C20.0824 17.694 21.654 18.4709 21.9771 18.6317C22.3003 18.794 22.5134 18.871 22.5917 19.0071C22.6687 19.1433 22.6687 19.7826 22.4034 20.5334Z"
      fill="currentColor"
    />
  ),
  reset: (
    <path
      d="M24 16c0 4.4-3.6 8-8 8-2.3 0-4.3-1-5.8-2.5l1.4-1.8c1 1.2 2.6 2 4.4 2 3.2 0 5.7-2.5 5.7-5.7s-2.5-5.7-5.7-5.7c-3 0-5.3 2.3-5.6 5.1h1l-1.1 1.1-1.1 1.1-1.1-1.1-1.1-1.1h1.1c.2-4.2 3.7-7.4 7.9-7.4 4.4 0 8 3.6 8 8z"
      fill="currentColor"
    />
  ),
  '360-view': (
    <path
      d="M15.5555 21.3765C13.1111 21.3765 11.1111 20.9142 9.11113 20.6831C6.66667 20.2207 4.66667 19.5272 3.55555 18.8337C2.22222 18.1401 1.33333 16.9843 1.33333 16.0596C1.33333 15.5973 1.55555 15.1349 1.77778 14.6726C0.666667 15.1349 0 16.2908 0 17.2155C0 20.4519 6.88887 23.2259 15.5555 23.4571V26L20 22.3013L15.5555 18.6025V21.3765ZM31.7778 14.4414C32 14.9037 32.2222 15.3661 32.2222 15.8285C32.2222 16.9843 31.5555 17.909 30 18.8337C28 20.2207 24.4444 21.1454 20 21.3765V23.6883C27.5555 22.9948 33.3333 20.4519 33.3333 17.2155C33.3333 16.2908 32.8889 15.3661 31.7778 14.4414ZM9.30233 9.04453C9.12873 9.28387 9.04513 9.60667 9.0527 10.0085H7.60959C7.62373 9.60213 7.69099 9.21613 7.81033 8.85707C7.93733 8.53207 8.13587 8.23633 8.40713 7.9654C8.61007 7.77353 8.84987 7.62681 9.12873 7.5252C9.40759 7.42359 9.74939 7.37393 10.1541 7.37393C10.9061 7.37393 11.5137 7.57487 11.9738 7.979C12.436 8.38307 12.6661 8.92713 12.6661 9.60893C12.6661 10.0898 12.5283 10.4961 12.2537 10.828C12.0801 11.0334 11.8989 11.1757 11.7112 11.2501C11.8523 11.2501 12.0551 11.3766 12.3188 11.6271C12.7127 12.0087 12.9102 12.5279 12.9102 13.1849C12.9102 13.8779 12.6791 14.4875 12.219 14.9779C11.7567 15.4705 11.0742 15.7158 10.1703 15.7158C9.056 15.7158 8.28233 15.4199 7.84833 14.8301C7.62047 14.4284 7.49333 13.9357 7.46853 13.3522H8.98759C8.98759 13.6773 9.03859 13.9482 9.13953 14.1649C9.32727 14.5577 9.66907 14.7564 10.1649 14.7564C10.4687 14.7564 10.7335 14.6481 10.9603 14.4313C11.186 14.2146 11.2988 13.9031 11.2988 13.5301C11.2988 12.9594 11.0894 12.6005 10.6695 12.4199C10.4308 12.3183 10.0543 12.2686 9.54099 12.2686V11.1173C10.0434 11.1082 10.395 11.0585 10.5935 10.9637C10.9375 10.8057 11.1089 10.4851 11.1089 10.0043C11.1089 9.69267 11.0211 9.44093 10.8453 9.24347C10.6706 9.04373 10.4232 8.94667 10.1053 8.94667C9.73959 8.94667 9.47267 8.97967 9.30233 9.04453ZM16.7513 10.2862C17.449 10.2862 18.023 10.5323 18.4679 11.0244C18.9149 11.5165 19.1385 12.1464 19.1385 12.9139C19.1385 14.0126 18.9193 14.852 18.4831 15.4367C18.0447 16.0191 17.3644 16.3104 16.4421 16.3104C15.4514 16.3104 14.7201 15.8792 14.2502 15.0168C13.8845 14.3441 13.7023 13.4416 13.7023 12.3449C13.7023 11.7529 13.7272 11.245 13.7782 10.8522C13.8683 10.1569 14.0441 9.57893 14.3045 9.11387C14.5291 8.72107 14.8221 8.4027 15.1867 8.16113C15.5491 7.91967 15.9842 7.8 16.4909 7.8C17.2211 7.8 17.8038 7.99413 18.2379 8.38507C18.6719 8.77307 18.9171 9.29227 18.9713 9.94013H17.4295C17.4295 9.80693 17.3807 9.66247 17.283 9.50107C17.1169 9.24933 16.8652 9.12067 16.5289 9.12067C16.0265 9.12067 15.6684 9.41413 15.4546 10.001C15.3385 10.3239 15.2593 10.8025 15.2159 11.4346C15.408 11.1976 15.6304 11.0237 15.8832 10.9154C16.1361 10.807 16.4258 10.7529 16.7513 10.7529ZM15.7097 11.8213C15.4058 12.0651 15.2539 12.4602 15.2539 12.9709C15.2539 13.4134 15.3679 13.7723 15.5957 14.0501C15.8236 14.3277 16.1133 14.4677 16.4637 14.4677C16.8077 14.4677 17.0779 14.3322 17.2743 14.0636C17.4718 13.7949 17.5705 13.445 17.5705 13.0161C17.5705 12.5397 17.4588 12.1407 17.2341 11.8856C17.0095 11.6327 16.735 11.5063 16.4095 11.5063C16.1459 11.5063 15.9125 11.5876 15.7097 11.8213ZM22.5955 15.7157C21.5929 15.7157 20.8897 15.3667 20.4883 14.7042C20.0847 14.0417 19.8828 13.0009 19.8828 11.582C19.8828 10.1653 20.0847 9.1223 20.4883 8.45757C20.8897 7.78827 21.5929 7.45587 22.5955 7.45587C23.5959 7.45587 24.3012 7.78827 24.7049 8.45757C25.1063 9.1223 25.3081 10.1653 25.3081 11.582C25.3081 13.0009 25.1063 14.0417 24.7027 14.7042C24.2991 15.3667 23.5959 15.7157 22.5955 15.7157ZM23.5005 13.7402C23.6415 13.2435 23.7131 12.5234 23.7131 11.582C23.7131 10.5977 23.6415 9.86627 23.4983 9.39217C23.3551 8.91813 23.0534 8.68333 22.5955 8.68333C22.1354 8.68333 21.8316 8.91813 21.684 9.39217C21.5343 9.86627 21.4605 10.5977 21.4605 11.582C21.4605 12.5234 21.5343 13.2435 21.684 13.7425C21.8316 14.2414 22.1354 14.4897 22.5955 14.4897C23.0534 14.4897 23.3572 14.2391 23.5005 13.7402ZM29.2144 7.89317C29.5573 8.25437 29.7287 8.68333 29.7287 9.18C29.7287 9.67667 29.5573 10.1033 29.2101 10.4623C28.865 10.8212 28.4549 11.0019 27.9774 11.0019C27.5 11.0019 27.0877 10.8213 26.7426 10.4623C26.3976 10.1033 26.2239 9.67667 26.2239 9.18C26.2239 8.68333 26.3975 8.25437 26.7426 7.89547C27.0877 7.53653 27.5 7.35593 27.9774 7.35593C28.4549 7.35593 28.8672 7.53427 29.2144 7.89317ZM28.5959 9.82113C28.7652 9.64507 28.8498 9.4306 28.8498 9.18C28.8498 8.92713 28.7652 8.71267 28.5959 8.534C28.4245 8.35827 28.2183 8.27033 27.9774 8.27033C27.7343 8.27033 27.5282 8.35827 27.3589 8.534C27.1875 8.71267 27.1029 8.92713 27.1029 9.18C27.1029 9.4306 27.1875 9.64507 27.3589 9.82113C27.5282 10.0028 27.7344 10.0875 27.9774 10.0875C28.2183 10.0875 28.4245 10.0028 28.5959 9.82113Z"
      transform="scale(0.95)"
      fill="currentColor"
    />
  ),
}

type Props = {
  icon: keyof Icons
  className?: string
}

export const Icon: FC<Props> = ({ icon, className, ...rest }) => {
  return icons[icon] ? (
    <svg viewBox="0 0 32 32" className={cn('h-8 w-8', className)} {...rest}>
      {icons[icon]}
    </svg>
  ) : null
}
